import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import SomeFacebookSquareLogoSvgInverted from "src/components/svg/SomeFacebookSquareLogoSvgInverted";
import SomeInstagramSquareLogoSvg from "src/components/svg/SomeInstagramSquareLogoSvg";
import SomeInstagramSquareLogoSvgInverted from "src/components/svg/SomeInstagramSquareLogoSvgInverted";
import SomeTikTokLogoSvg from "src/components/svg/SomeTikTokLogoSvg";
import SomeTikTokLogoSvgInverted from "src/components/svg/SomeTikTokLogoSvgInverted";
import theme from "src/components/themes/DefaultTheme";
import styled, { css } from "src/lib/styles/css";

//#region [Props]
type ArticleSoMeRowProps = {
    className?: string;
    label: string;
};
//#endregion

//#region [Component]
export default function ArticleSoMeRow({ className, label }: ArticleSoMeRowProps) {
    return <SArticleSoMeRowContainer className={className}>
        <SLabel className="label">{label}</SLabel>
        <SLink to="https://www.facebook.com/filmweb.no" rel="noopener noreferrer"><SSomeFacebookSquareLogoSvg /></SLink>
        <SLink to="https://www.instagram.com/filmwebno/" rel="noopener noreferrer"><SSomeInstagramSquareLogoSvg /></SLink>
        <SLink to="https://www.tiktok.com/@filmweb.no" rel="noopener noreferrer"><SSomeTikTokLogoSvg /></SLink>
    </SArticleSoMeRowContainer>;
}
//#endregion

//#region [Styles]

const SArticleSoMeRowContainer = styled.div`
    --ICONCOLOR_OVERRIDE: var(--path-fill-color, ${theme.bgColor});
    display: flex;
    align-items: center;
    gap: 1em;
    margin-top: 25px;
    flex-wrap: wrap;
    @media (min-width: 550px) {
        margin-top: 0;
        flex-wrap: nowrap;
    }

`;

const cssIcon = css`
    flex: 0 0 auto;
    width: 28px;
    height: 28px;
    display: block;
    .gradient {
        background: ${theme.palette.conicGradient};
        width: 100%;
        height: 100%;
    }

`;

const SLink = styled(FilmwebLink)`
    display: block;
`;

const SLabel = styled.div`
    font-size: 0.888888em;
    line-height: 1;
    flex: 0 1 auto;
    @media (min-width: 550px) {
        white-space: nowrap;
    }
`;

const SSomeFacebookSquareLogoSvg = styled(SomeFacebookSquareLogoSvgInverted)`
    ${cssIcon}

`;

const SSomeInstagramSquareLogoSvg = styled(SomeInstagramSquareLogoSvgInverted)`
    ${cssIcon}
`;

const SSomeTikTokLogoSvg = styled(SomeTikTokLogoSvgInverted)`
    ${cssIcon}
`;
//#endregion